import { MinimalUser } from '../../interfaces/User';

const STORE_KEY = 'de.dew21.store.MINIMAL_USERS_CACHE';

export const set = (data: MinimalUser[]) => {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(data));
  } catch (e) {
    //
  }
}

export const get = (): MinimalUser[] => {
  try {
    return JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
  } catch (e) {
    //
  }
  return [];
}
